'use client';

import * as React from 'react';
import { mergeProps } from "../merge-props/index.js";
import { useComponentRenderer } from "../utils/useComponentRenderer.js";

/**
 * A separator element accessible to screen readers.
 * Renders a `<div>` element.
 *
 * Documentation: [Base UI Separator](https://base-ui.com/react/components/separator)
 */
export const Separator = /*#__PURE__*/React.forwardRef(function SeparatorComponent(props, forwardedRef) {
  const {
    className,
    render,
    orientation = 'horizontal',
    ...other
  } = props;
  const state = React.useMemo(() => ({
    orientation
  }), [orientation]);
  const getSeparatorProps = React.useCallback((externalProps = {}) => mergeProps({
    'aria-orientation': orientation
  }, externalProps), [orientation]);
  const {
    renderElement
  } = useComponentRenderer({
    propGetter: getSeparatorProps,
    render: render ?? 'div',
    className,
    state,
    extraProps: {
      role: 'separator',
      ...other
    },
    ref: forwardedRef
  });
  return renderElement();
});
if (process.env.NODE_ENV !== "production") Separator.displayName = "Separator";